"use client";

import type { HTMLProps } from "react";
import { useEffect } from "react";

import { cn } from "@/lib/utils";
import { useSearchStore } from "@/stores/searchStore";

import { useSearch } from "./Context";

const SearchList = ({
  children,
  className,
  ...props
}: HTMLProps<HTMLUListElement>) => {
  const { selected, open, setOpen } = useSearch();
  const setSearchFocus = useSearchStore((state) => state.setSearchFocus);

  useEffect(() => {
    return () => {
      setOpen(false);
      setSearchFocus(false);
    };
  }, [setSearchFocus, setOpen]);

  if (!open) return null;

  return (
    <ul
      data-active={selected}
      className={cn(
        "absolute top-full left-0 z-50 flex min-w-full -translate-y-[2px] flex-col bg-inherit",
        className,
      )}
      {...props}
    >
      {children}
    </ul>
  );
};

SearchList.displayName = "SearchList";

export default SearchList;
